<template>
  <div class="page-content campus-list">
    <div class="swichNav clearfix">
      <div
        class="ser"
        :class="item.id == switchId ? 'clicked' : ''"
        @click="btnClickSwich(item.id)"
        v-for="item in headerSwichData"
        :key="item.id"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="header">
      <div class="searchBox ser">
        <a-auto-complete
          v-model="searchValue"
          style="width: 150px"
          placeholder="检索"
        />
        <a-select
          v-if="showFlagSwitch"
          allowClear
          v-model="stageId"
          style="width: 150px; margin-left: 10px"
          placeholder="参赛阶段"
        >
          <a-select-option
            v-for="(item, index) in headerListIm"
            :key="index"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-select
          allowClear
          v-model="trackId"
          style="width: 150px; margin-left: 10px"
          placeholder="赛道"
        >
          <a-select-option
            v-for="(item, index) in trackData"
            :key="index"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-select
          allowClear
          v-model="categoryId"
          style="width: 150px; margin-left: 10px"
          placeholder="类别"
        >
          <a-select-option
            v-for="(item, index) in categoryData"
            :key="index"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="btnBox ser">
        <a-button type="primary" @click="btnexport"> 导出名单 </a-button>
        <a-button type="primary" style="margin-left: 5px" @click="btnChange">
          参数阶段变更
        </a-button>
        <a-button
          type="primary"
          style="margin-left: 5px"
          @click="showModalAddList"
        >
          添加赛事
        </a-button>
      </div>
    </div>
    <div class="navList">
      <a-table
        tableLayout="auto"
        :data-source="attendData"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: selectChange,
        }"
        :rowKey="(attendData) => attendData.id"
        :scroll="{ x: 1500 }"
        :pagination="{
          total: total,
          pageSize: pageSize,
          current: current,
          showTotal: (total) =>
            $t('public.page', { total: total, pageSize: pageSize }),
          onChange: currentChange,
        }"
      >
        <a-table-column
          :width="200"
          title="项目名称"
          dataIndex="itemName"
        >
          <template slot-scope="itemName">
            <div class="macSetter">
              {{ itemName }}
            </div>
          </template>
        </a-table-column>
        <a-table-column title="负责人姓名" dataIndex="name">
          <template slot-scope="name">
            <div class="macSetter">
              {{ name }}
            </div>
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          title="手机号"
          dataIndex="phone"
        >
          <template slot-scope="phone">
            <div class="macSetter">
              {{ phone }}
            </div>
          </template>
        </a-table-column>
        <a-table-column
          :width="200"
          title="负责人邮箱"
          dataIndex="email"
        >
        </a-table-column>
        <a-table-column title="学校" dataIndex="schoolName">
          <template slot-scope="schoolName">
            <div class="macSetter">
              {{ schoolName }}
            </div>
          </template>
        </a-table-column>
        <a-table-column
          :width="200"
          title="所在院系"
          dataIndex="college"
        >
          <template slot-scope="college">
            <div class="macSetter">
              {{ college }}
            </div>
          </template>
        </a-table-column>
        <a-table-column
          fixed="right"
          title="操作"
          dataIndex="id"
        >
          <template slot-scope="id, attendData">
            <a @click="showDrawer(attendData.id)">查看详情</a>
            <div class="border"></div>
            <a-popconfirm
              title="确定删除?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="btnDelect(attendData.id)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </a-table-column>
      </a-table>
      <!-- </a-tab-pane>
      </a-tabs> -->
    </div>
    <a-modal v-model="modalVisible" title="添加届数" @ok="handleOkAddList">
      <a-form
        :form="addSessionForm"
        :label-col="{ span: 10 }"
        :wrapper-col="{ span: 10 }"
        @submit="addproject"
        labelAlign="left"
      >
        <a-form-item label="入学时间">
          <a-month-picker
            format="YYYY-MM-DD"
            placeholder="入学时间"
            v-decorator="[
              'enrollDate',
              {
                rules: [{ required: true, message: '请选择入学时间' }],
              },
            ]"
            @change="enrollDateOnChange"
          />
        </a-form-item>
        <a-form-item label="毕业时间">
          <a-month-picker
            format="YYYY-MM-DD"
            placeholder="毕业时间"
            v-decorator="[
              'graduateDate',
              {
                rules: [{ required: true, message: '请选择毕业时间' }],
              },
            ]"
            @change="graduateDateOnChange"
          />
        </a-form-item>
        <a-form-item label="报名时间">
          <a-month-picker
            format="YYYY-MM-DD"
            placeholder="报名时间"
            v-decorator="[
              'signUpDate',
              {
                rules: [{ required: true, message: '请选择报名时间' }],
              },
            ]"
            @change="signUpDateOnChange"
          />
        </a-form-item>
        <a-form-item label="项目名称">
          <a-input
            placeholder="请填写项目名称"
            v-decorator="[
              'itemName',
              {
                rules: [{ required: true, message: '请输入项目名称' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="项目概述">
          <a-input
            placeholder="请填写项目概述"
            v-decorator="[
              'itemIntro',
              {
                rules: [{ required: true, message: '请输入项目概述' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="负责人姓名">
          <a-input
            placeholder="请填写负责人姓名"
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '请输入负责人姓名' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="负责人手机号码">
          <a-input
            placeholder="请填写手机号码"
            v-decorator="[
              'telephone',
              {
                rules: [{ required: true, message: '请填写手机号码' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="负责人邮箱">
          <a-input
            placeholder="请填写负责人邮箱"
            v-decorator="[
              'email',
              {
                rules: [{ required: true, message: '请填写负责人邮箱' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="学校">
          <a-input
            placeholder="请填写学校"
            v-decorator="[
              'school',
              {
                rules: [{ required: true, message: '请输入学校' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="所在院系">
          <a-input
            placeholder="请填写所在院系"
            v-decorator="[
              'faculty',
              {
                rules: [{ required: true, message: '请输入所在院系' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="学号">
          <a-input
            placeholder="请填写学号"
            v-decorator="[
              'studyNo',
              {
                rules: [{ required: true, message: '请输入学号' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="学历层次">
          <a-input
            placeholder="请填写学历层次"
            v-decorator="[
              'education',
              {
                rules: [{ required: true, message: '请输入学历层次' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="专业名称">
          <a-input
            placeholder="请填写专业名称"
            v-decorator="[
              'major',
              {
                rules: [{ required: true, message: '请输入专业名称' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="省份">
          <a-input
            placeholder="请填写省份"
            v-decorator="[
              'province',
              {
                rules: [{ required: true, message: '请输入省份' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="赛道">
          <a-input
            placeholder="请填写届数"
            v-decorator="[
              'track',
              {
                rules: [{ required: true, message: '请输入赛道' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="参赛组别">
          <a-input
            placeholder="请填写参赛组别"
            v-decorator="[
              'competitionGroup',
              {
                rules: [{ required: true, message: '请输入参赛组别' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="参赛类别">
          <a-input
            placeholder="请填写参赛类别"
            v-decorator="[
              'competitionType',
              {
                rules: [{ required: true, message: '请输入参赛类别' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="项目进展">
          <a-input
            placeholder="请填写项目进展"
            v-decorator="[
              'itemProgress',
              {
                rules: [{ required: true, message: '请输入项目进展' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="参赛阶段">
          <a-input
            placeholder="请填写参赛阶段"
            v-decorator="[
              'competitionProgress',
              {
                rules: [{ required: true, message: '请输入参赛阶段' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="学校科技成果转化">
          <!-- 12321332213 -->
          <a-select
            placeholder="请选择"
            style="width: 100%"
            v-decorator="[
              'resultTransfer',
              {
                rules: [{ required: true, message: '请输入学校科技成果转化' }],
              },
            ]"
          >
            <a-select-option value="是"> 是 </a-select-option>
            <a-select-option value="否"> 否 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="师生共创">
          <a-select
            placeholder="请选择"
            style="width: 100%"
            v-decorator="[
              'bothInvention',
              {
                rules: [{ required: true, message: '请填写师生共创' }],
              },
            ]"
          >
            <a-select-option value="是"> 是 </a-select-option>
            <a-select-option value="否"> 否 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="是成果的完成人或所有人...">
          <a-select
            placeholder="请选择"
            style="width: 100%"
            v-decorator="[
              'competitionOwner',
              {
                rules: [
                  {
                    required: true,
                    message: '是成果的完成人或所有人...',
                  },
                ],
              },
            ]"
          >
            <a-select-option value="是"> 是 </a-select-option>
            <a-select-option value="否"> 否 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="是成果的第一完成人...">
          <a-select
            placeholder="请选择"
            style="width: 100%"
            v-decorator="[
              'competitionFirst',
              {
                rules: [
                  {
                    required: true,
                    message: '是成果的第一完成人...',
                  },
                ],
              },
            ]"
          >
            <a-select-option value="是"> 是 </a-select-option>
            <a-select-option value="否"> 否 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="国家级重大.重点科研项目...">
          <a-select
            placeholder="请选择"
            style="width: 100%"
            v-decorator="[
              'importantItem',
              {
                rules: [
                  {
                    required: true,
                    message: '国家级重大、重点科研项目...',
                  },
                ],
              },
            ]"
          >
            <a-select-option value="是"> 是 </a-select-option>
            <a-select-option value="否"> 否 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="隐私设置">
          <a-input
            placeholder="请填写隐私设置"
            v-decorator="[
              'privateSetting',
              {
                rules: [{ required: true, message: '请输入隐私设置' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="国赛获奖情况">
          <a-input
            placeholder="请填写国赛获奖情况"
            v-decorator="[
              'nationAwardConditition',
              {
                rules: [{ required: true, message: '请输入国赛获奖情况' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="省赛获奖情况">
          <a-input
            placeholder="请填写省赛获奖情况"
            v-decorator="[
              'provinceAwardCondition',
              {
                rules: [{ required: true, message: '请输入省赛获奖情况' }],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model="modalVisibleChange"
      title="参数阶段变更"
      @ok="handleOkAddListChange"
    >
      <a-form
        :form="modelFormChange"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmitChange"
      >
        <a-form-item label="参数变更阶段">
          <a-select
            placeholder="选择参数变更阶段"
            v-decorator="[
              'attendType',
              {
                rules: [{ required: true, message: '选择参数变更阶段' }],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) in modelSelectStage"
              :key="index"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-drawer
      width="640"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      wrapClassName="wrapClassName"
    >
      <p :style="[pStyle, pStyle2]">项目详细信息</p>
      <p :style="pStyle">个人信息</p>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>负责人姓名</span>
            <span>&nbsp;{{ drwaDataItem.name }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>手机号</span>
            <span>&nbsp;{{ drwaDataItem.phone }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>负责人邮箱</span>
            <span>&nbsp;{{ drwaDataItem.email }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>学号</span>
            <span>&nbsp;{{ drwaDataItem.studentNo }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>学校</span>
            <span>&nbsp;{{ drwaDataItem.schoolName }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>院系</span>
            <span>&nbsp;{{ drwaDataItem.college }}</span>
          </div>
        </a-col>
      </a-row>
      <!-- <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>学校</span>
            <span>&nbsp;Lily</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>院系</span>
            <span>&nbsp;Lily</span>
          </div>
        </a-col>
      </a-row> -->
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>学历层次</span>
            <span>&nbsp;{{ drwaDataItem.education }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>专业名称</span>
            <span>&nbsp;{{ drwaDataItem.specialityName }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>入学时间</span>
            <span>&nbsp;{{ drwaDataItem.entranceTime }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>毕业时间</span>
            <span>&nbsp;{{ drwaDataItem.graduateTime }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>省份</span>
            <span>&nbsp;{{ drwaDataItem.location }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>报名时间</span>
            <span>&nbsp;{{ drwaDataItem.createTime }}</span>
          </div>
        </a-col>
      </a-row>
      <a-divider />
      <p :style="pStyle">项目信息</p>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>项目名称</span>
            <span>&nbsp;{{ drwaDataItem.itemName }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>赛道</span>
            <span>&nbsp;{{ drwaDataItem.track }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>参赛组别</span>
            <span>&nbsp;{{ drwaDataItem.competitionGroup }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>参赛类别</span>
            <span>&nbsp;{{ drwaDataItem.competitionType }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span> 项目进展</span>
            <span>&nbsp;{{ drwaDataItem.itemProgress }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>参赛阶段</span>
            <span>&nbsp;{{switchId == 1 ?'预报名':drwaDataItem.attendProgress}}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>学校科技成果转化</span>
            <span>&nbsp;{{ drwaDataItem.resultTransfer }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span>师生共创</span>
            <span>&nbsp;{{ drwaDataItem.bothInvention }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>是成果的完成人或所有人....</span>
            <span>&nbsp;{{ drwaDataItem.competitionOwner }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span> 是成果的第一完成人...</span>
            <span>&nbsp;{{ drwaDataItem.competitionFirst }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="drawItem">
            <span>国家级重大.重点科研项目....</span>
            <span>&nbsp;{{ drwaDataItem.importantItem }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="drawItem">
            <span> 隐私设置</span>
            <span>&nbsp;{{ drwaDataItem.privateSetting }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12" v-if="switchId == 2">
          <div class="drawItem">
            <span>国赛获奖情况</span>
            <span>&nbsp;{{ drwaDataItem.nationAwardConditition }}</span>
          </div>
        </a-col>
        <a-col :span="12" v-if="switchId == 2">
          <div class="drawItem">
            <span> 省赛获奖情况</span>
            <span>&nbsp;{{ drwaDataItem.provinceAwardCondition }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <div class="drawItem">
            <span>项目简介</span>
            <span>&nbsp;{{ drwaDataItem.itemIntro }}</span>
          </div>
        </a-col>
      </a-row>
      <a-divider />
    </a-drawer>
    <a-modal
      title="导出项目"
      :visible="visibleExpotant"
      @ok="handleOkTips"
      @cancel="visibleExpotant = false"
    >
      <p>确定导出{{ total }}条数据吗</p>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../../config/index.js'

export default {
  data() {
    return {
      visible: false,
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px',
      },
      pStyle2: {
        marginBottom: '24px',
      },
      // searchModel: '', //搜索学习中心
      addSessionForm: this.$form.createForm(this, { name: 'addSessionForm' }),
      switchId: 1,
      modalVisibleChange: false,
      headerSwichData: [
        {
          name: '校赛预报名名单',
          id: 1,
        },
        {
          name: '正式参选名单',
          id: 2,
        },
      ],
      tableLoading: false,
      visibleExpotant: false,
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      modelFormChange: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
      },
      uploadLoading: false,
      searchValue: '',
      selectedRowKeys: [],
      pageSize: 10,
      total: 0,
      current: 1,
      approvalList: [],
      attendData: [],
      dataSource: [],
      headerListIm: [
        {
          name: '全部',
        },
        {
          key: 0,
          name: '报名',
        },
        {
          key: 1,
          name: '校赛（初赛）',
        },
        {
          key: 2,
          name: '校赛（复赛）',
        },
        {
          key: 3,
          name: '校赛（决赛)',
        },
        {
          key: 4,
          name: '推荐市赛',
        },
        {
          key: 5,
          name: '市赛（复赛）',
        },
        {
          key: 6,
          name: '市赛（决赛）',
        },
        {
          key: 7,
          name: '推荐国赛',
        },
        {
          key: 8,
          name: '国赛网评',
        },
        {
          key: 9,
          name: '现场总决赛',
        },
      ],
      headerListNo: [
        {
          name: '全部',
          key: '',
        },
        {
          key: 0,
          name: '报名',
        },
        {
          key: 1,
          name: '校赛',
        },
        {
          key: 2,
          name: '市赛',
        },
        {
          key: 3,
          name: '国赛',
        },
      ],
      headerList: [],
      matchType: '',
      matchId: '',
      attendType: 0,
      enrollDate: '',
      graduateDate: '',
      signUpDate: '',
      attendBtnType: null,
      btnEditId: null,
      trackData: [
        {
          name: '全部',
        },
        {
          name: '高教主赛道',
        },
        {
          name: '青年红色筑梦之旅赛道',
        },
      ],
      categoryData: [
        {
          name: '互联网+现代农业',
        },
        {
          name: '互联网+制造业',
        },
        {
          name: '互联网+信息技术服务',
        },
        {
          name: '互联网+社会服务',
        },
        {
          name: '互联网+文化创意服务',
        },
      ],
      stageId: undefined,
      categoryId: undefined,
      trackId: undefined,
      showFlagSwitch: false,
      modelSelectStage: [],
      selectedRowKeys: [],
      drwaDataItem: {},
    }
  },

  props: {
    updateComponent: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters(['handleRightsList', 'sidebarRouterList']),
  },

  watch: {
    //类别
    categoryId(val) {
      this.current = 1;
      this.getPAgeData(this.attendType, '')
    },
    //阶段
    stageId(val) {
      this.current = 1;

      this.getPAgeData(this.attendType, '')
    },
    //赛道
    trackId(val) {
      this.current = 1;
      this.getPAgeData(this.attendType, '')
    },
    searchValue(val) {
      this.current = 1;
      this.getPAgeData(this.attendType, val)
    },
  },

  created() {
    this.modelSelectStage = this.headerListIm.slice(1, this.headerListIm.length)
    this.matchType = this.$route.query.matchType
    this.matchId = this.$route.query.id
    //对赛事进行筛选
    if (this.matchType == 1) {
      this.headerList = this.headerListIm
    } else {
      this.headerList = this.headerListNo
    }
    this.getPAgeData(this.attendType, '')
  },

  methods: {
    downloadFileByBlob(fileBlob) {
      let fileName = `课程名单.xls`
      const link = document.createElement('a')
      let blob = new Blob([fileBlob], { type: 'application/vnd.ms-excel' })
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      // link.download = res.headers['content-disposition'] //下载后文件名
      link.download = fileName //下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.visibleExpotant = false
      this.$message.success(this.$t('public.successfullyExported'))
      this.exportLoading = false
    },
    handleOkTips() {
      this.exportLoading = true
      let data = {
        campus: this.campus,
        courseName: this.courseName,
        track: this.trackId == '全部' ? '' : this.trackId,
        attendType: !this.showFlagSwitch
          ? '预报名'
          : this.stageId == '全部'
          ? ''
          : this.stageId,
        id: this.matchId,
      }
      console.log(config.baseURL, this.$api.NAMELISTEXPORT)
      this.$axios({
        method: 'POST',
        url: config.baseURL + this.$api.NAMELISTEXPORT,
        data: data,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        responseType: 'arraybuffer',
      }).then((r) => {
        console.log(r)
        this.downloadFileByBlob(r.data)
      })
    },
    showDrawer(id) {
      let drwaData = this.attendData.find((Element) => {
        return Element.id == id
      })
      this.drwaDataItem = drwaData
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleOkAddListChange() {
      this.handleSubmitChange()
    },
    handleSubmitChange() {
      this.modelFormChange.validateFields((err, data) => {
        if (!err) {
          if (this.selectedRowKeys.length == 0) {
            this.$message.error('未选择变更的项目')
            return false
          }
          data.ids = this.selectedRowKeys
          this.modalVisibleChange = false
          console.log('Received values of form: ', data)
          //编辑基金
          this.$http(this.$api.BATCHUPDATE, data).then((r) => {
            console.log(r)
            this.getPAgeData(this.attendType, '')
            this.$notification.open({
              type: 'success',
              message: '参数变更',
              description: '参数变更成功',
            })
          })
        }
      })
    },
    btnexport() {
      if (this.total == 0) {
        this.$message.error('当前没有可用的数据')
        return false
      }
      this.visibleExpotant = true
    },
    btnChange() {
      this.modalVisibleChange = true
    },
    btnClickSwich(id) {
      this.switchId = id
      if (id == 2) {
        this.showFlagSwitch = true
      } else {
        this.showFlagSwitch = false
      }
      this.getPAgeData(this.attendType, '')
    },
    btnEdit(id) {
      this.btnEditId = id
      this.attendBtnType = 1
      this.modalVisible = true
      let itemData = this.attendData.find((Element) => {
        return Element.id == id
      })
      console.log(itemData)
      this.$nextTick(() => {
        this.addSessionForm.setFieldsValue({
          attendType: itemData.attendType,
          bothInvention: itemData.bothInvention,
          competitionFirst: itemData.competitionFirst,
          competitionGroup: itemData.competitionGroup,
          competitionOwner: itemData.competitionOwner,
          competitionProgress: itemData.competitionProgress,
          competitionType: itemData.competitionType,
          education: itemData.education,
          email: itemData.email,
          enrollDate: itemData.enrollDate,
          faculty: itemData.faculty,
          graduateDate: itemData.graduateDate,
          importantItem: itemData.importantItem,
          itemIntro: itemData.itemIntro,
          itemName: itemData.itemName,
          itemProgress: itemData.itemProgress,
          leader: itemData.leader,
          major: itemData.major,
          matchAwardRecordId: itemData.matchAwardRecordId,
          nationAwardConditition: itemData.nationAwardConditition,
          privateSetting: itemData.privateSetting,
          province: itemData.province,
          provinceAwardCondition: itemData.provinceAwardCondition,
          resultTransfer: itemData.resultTransfer,
          school: itemData.school,
          signUpDate: itemData.signUpDate,
          studyNo: itemData.studyNo,
          telephone: itemData.telephone,
          track: itemData.track,
        })
      })
    },
    btnDelect(id) {
      let data = {
        id,
      }
      this.$http(this.$api.DELECTATTENDDATA, data).then(() => {
        this.getPAgeData(this.attendType, '')
        this.$notification.open({
          type: 'success',
          message: '删除赛事',
          description: '删除成功',
        })
      })
    },
    changeTab(key) {
      console.log(key)
      this.current = 1
      this.attendType = key
      this.getPAgeData(key, '')
    },
    enrollDateOnChange(r, data) {
      this.enrollDate = data
    },
    signUpDateOnChange(r, data) {
      this.signUpDate = data
    },
    graduateDateOnChange(r, data) {
      this.graduateDate = data
    },
    showModalAddList() {
      this.attendBtnType = 2
      this.modalVisible = true
    },
    addproject() {
      this.addSessionForm.validateFields((err, data) => {
        let serveData = data
        serveData.enrollDate = this.enrollDate
        serveData.graduateDate = this.graduateDate
        serveData.signUpDate = this.signUpDate
        serveData.matchAwardRecordId = this.matchId
        serveData.attendType = this.attendType
        serveData.id = this.btnEditId
        console.log(serveData)
        if (!err) {
          if (this.attendBtnType == 1) {
            this.$http(this.$api.UPDATEATTENDDATA, serveData).then((r) => {
              console.log(r)
              this.getPAgeData(this.attendType, '')
              this.$notification.open({
                type: 'success',
                message: '修改赛事',
                description: '修改成功',
              })
            })
          } else if (this.attendBtnType == 2) {
            this.$http(this.$api.ADDATTENDDATA, serveData).then((r) => {
              console.log(r)
              this.getPAgeData(this.attendType, '')
              this.$notification.open({
                type: 'success',
                message: '添加赛事',
                description: '添加成功',
              })
            })
          }
        }
      })
    },
    handleOkAddList() {
      this.modalVisible = false
      this.addproject()
    },
    getPAgeData(attendType, itemName) {
      // awardId/赛事届数id attendType/赛事类型
      let data = {
        attendType: !this.showFlagSwitch
          ? '预报名'
          : this.stageId == undefined
          ? ''
          : this.stageId,
        competitionType: this.categoryId == undefined ? '' : this.categoryId,
        track: this.trackId == undefined ? '' : this.trackId,
        itemName,
        pageSize: this.pageSize,
        pageNum: this.current,
        id: this.matchId,
      }
      this.$http(this.$api.GETSTUDENTMATCHDATA, data).then((r) => {
        console.log(r)
        this.$nextTick(() => {
          this.attendData = r.data.records
          this.total = r.data.total
        })
      })
    },
    // 分页
    currentChange(val) {
      this.current = val
      this.getPAgeData(this.attendType, '')
    },
  },
}
</script>
<style scoped lang="less">
/deep/ .drawItem {
  // font-size: 15px;
  margin-top: 8px;
  span:nth-child(1) {
    color: black;
    margin-right: 10px;
  }
  span:nth-child(2) {
    color: #474747;
  }
}
.page-content {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .swichNav {
    width: 100%;
    // height: 50px;
    padding: 0 20px;
    margin-top: 10px;
    border-bottom: 1px solid #e0e1e4;
    .ser {
      float: left;
      padding: 0 5px;
      box-sizing: border-box;
      font-size: 15px;
      height: 40px;
      line-height: 30px;
    }
    .ser:last-child {
      // border-left: 1px solid #929292;
      margin-left: 10px;
    }
  }
  .swichNav:hover {
    cursor: pointer;
  }
  .clicked {
    font-weight: bold;
    color:#a92233;
    border-bottom: 3px solid #a92233;
    box-sizing: border-box;
  }
  .macSetter {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 200px;
  }
  .header {
    width: 100%;
    height: 60px;
    padding: 0px 20px 0 20px;
    margin-top: 20px;
    box-sizing: border-box;
    .ser {
      float: left;
    }
    .ser:last-child {
      float: right;
    }
  }
  .navList {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}
</style>
